exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._35MjmWSBex2cfZhfBfTKqw{color:\"[theme:themePrimary, default:#0078D4]\"}._2haPsz3sF1KWTbQgXVtzvl{font-weight:400;font-size:14px}html[dir=ltr] ._2haPsz3sF1KWTbQgXVtzvl{padding-left:3px}html[dir=rtl] ._2haPsz3sF1KWTbQgXVtzvl{padding-right:3px}", ""]);
// Exports
exports.locals = {
	"reservationStatus": "_35MjmWSBex2cfZhfBfTKqw",
	"reservationStatusText": "_2haPsz3sF1KWTbQgXVtzvl"
};